(() => {
  if (customElements.get('apollo-box-viewer')) return;
  class ApolloBoxViewer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.stage = this.querySelector('[data-box-stage]');
      this.box = this.querySelector('[data-box]');
      this.buttons = [...this.querySelectorAll('[data-box-view]')];
      if (!this.stage || !this.box) return;
      this.pitch = -12;
      this.yaw = -24;
      this.draw();
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, pitch: this.pitch, yaw: this.yaw, active: false };
        if (event.pointerType === 'mouse') event.preventDefault();
      }, options);
      this.stage.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 5) return;
          if (event.pointerType === 'touch' && Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.active = true;
          this.stage.setPointerCapture(event.pointerId);
          this.stage.classList.add('is-dragging');
        }
        this.yaw = drag.yaw + dx * 0.55;
        this.pitch = Math.max(-90, Math.min(90, drag.pitch - dy * 0.4));
        this.draw();
      }, options);
      const end = event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        this.drag = null;
        this.stage.classList.remove('is-dragging');
      };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.stage.addEventListener(type, end, options));
      this.stage.addEventListener('pointerleave', event => { if (this.drag && !this.drag.active) end(event); }, options);
      this.stage.addEventListener('keydown', event => {
        const keys = { ArrowLeft: [-15, 0], ArrowRight: [15, 0], ArrowUp: [0, -10], ArrowDown: [0, 10] };
        if (keys[event.key]) {
          event.preventDefault();
          this.yaw += keys[event.key][0];
          this.pitch = Math.max(-90, Math.min(90, this.pitch + keys[event.key][1]));
          this.draw();
        } else if (event.key === 'Home') { event.preventDefault(); this.setView('reset'); }
      }, options);
      this.buttons.forEach(button => button.addEventListener('click', () => this.setView(button.dataset.boxView), options));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    setView(view) {
      const views = { front: [0, 0], right: [-90, 0], back: [180, 0], left: [90, 0], top: [0, -90], bottom: [0, 90], reset: [-24, -12] };
      const values = views[view];
      if (!values) return;
      [this.yaw, this.pitch] = values;
      this.draw(view);
    }
    draw(view) {
      this.box.style.transform = `rotateX(${this.pitch}deg) rotateY(${this.yaw}deg)`;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.boxView === view)));
    }
  }
  customElements.define('apollo-box-viewer', ApolloBoxViewer);
})();

